module.exports = __webpack_public_path__ + "img/platform.1fcb7c9.jpg";